<template>
  <el-select v-model="value" multiple collapse-tags collapse-tags-tooltip :max-collapse-tags="3"
    :placeholder="t('management.setup.role.form.selectPermissions')" class="w-full" @change="handleChange">
    <el-option v-for="opt in options" :key="opt.value" :label="opt.label" :value="opt.value" />
  </el-select>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouteNames, DirectiveNames, PageNames } from '@/acl/permissions';

const { t } = useI18n();

const $props = defineProps<{
  modelValue?: string[];
  permissionType?: 'routes' | 'functions' | 'itemEditor' | 'pages';
  rootFormData?: any;
}>();

const $emit = defineEmits(['update:modelValue']);

const value = ref($props.modelValue || []);

const mapToOptions = (values: string[], prefix: string) =>
  values.map(v => ({ value: v, label: t(`permissions.${prefix}.${v}`) }));

const options = computed(() => {
  switch ($props.permissionType) {
    case 'routes':
      return mapToOptions(Object.values(RouteNames), 'routes');
    case 'functions':
      return mapToOptions(Object.values(DirectiveNames).filter(v => v.startsWith('function_')), 'functions');
    case 'itemEditor':
      return mapToOptions(Object.values(DirectiveNames).filter(v => v === DirectiveNames.TABLE_EDITOR || v.startsWith('item_editor_')), 'itemEditor');
    case 'pages':
      return mapToOptions(Object.values(PageNames), 'pages');
    default:
      return [];
  }
});

const handleChange = () => $emit('update:modelValue', value.value);

watch(() => $props.modelValue, (val) => value.value = val || []);
</script>
